import { render, staticRenderFns } from "./token.vue?vue&type=template&id=1c30faa8&"
import script from "./token.vue?vue&type=script&lang=js&"
export * from "./token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsLogo: require('/home/plantenkennistrainer/vhg-plantenkennistrainer/trainer/components/icons/Logo.vue').default,IconsPlantsCollection: require('/home/plantenkennistrainer/vhg-plantenkennistrainer/trainer/components/icons/PlantsCollection.vue').default})
